import React, {useState, useEffect} from 'react';
import { FaEnvelope, FaLock, FaCheckCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import Toast from 'light-toast';
import logo from "../assets/medicare-club-logo.svg";
import bg from "../assets/partner-deal-red.jpg";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import {UserService} from "../services/user-service";

import {LoginPage, Container, LoginContent, LoginForm, InputDivOne, 
  InputIcon, InputRest, Input, InputDivPass, Button, Link } from "../styles";
import { Card, Alert } from 'react-bootstrap';

function useFormik({
    initialValues,
    validate
  }) {
    const [touched, setTouchedFields] = useState({});
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState(initialValues);
  
    useEffect(() => {
      validateValues(values);
    }, [values]);
  
    function handleChange(event) {
      const fieldName = event.target.getAttribute('name');
      const { value } = event.target;
      setValues({
        ...values,
        [fieldName]: value,
      });
    }
  
    function handleBlur(event) {
      const fieldName = event.target.getAttribute('name');
      setTouchedFields({
        ...touched,
        [fieldName]: true,
      })
    }
  
    function validateValues(values) {
      setErrors(validate(values));
    }
  
    return {
      values,
      errors,
      touched,
      handleBlur,
      setErrors,
      handleChange,
    };
}

function Login(props) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validate: function (values) {
          const errors = {};
        
          if(!values.email.includes('@')) {
            errors.email = 'E-mail não está correcto';
          }
        
          if(values.password.length < 4) {
            errors.password = 'Deve conter mais de 3 dígitos'
          }
        
          return errors;
        }
    });

    const history = useHistory();

    useEffect(()=> {
      const token = localStorage.getItem('provider_token');
      if(token) {
        history.push('/home');
      }
    });

    function loginClick(event) {
        event.preventDefault();
        setError(null);
        setLoading(true);
        UserService.login(formik.values).then((result)=> {
          setLoading(false);
          if(result.data && result.data.user_details.is_provider > 0) {
            localStorage.setItem('provider_token', result.data.token);
            history.push('/home');
          } else if(result.data && result.data.user_details.is_provider <= 0) {
            setError("Não é parceiro.");
            Toast.fail("Não é parceiro.", 1000);
          } else {
            setError(result.error);
            Toast.fail(result.error, 1000);
          }
        }, (err)=> {
          setError(err.error);
          // Toast.fail(err.error, 1000);
          setLoading(false);
        });
    }
    
    function forgetClick() {
        localStorage.removeItem('provider_token');
        localStorage.removeItem('provider_data');
        localStorage.removeItem('location_data');
        history.push("/reset-password")
    }

    return (
        <LoginPage style={{backgroundImage: `url(${bg})`}}>
          <Container>
            <div className="empty" style={{height:0}}></div> 
            <LoginContent>
              {props?.location.data &&
                <Alert variant="success">
                  <FaCheckCircle /> {props?.location.data}
                </Alert>
              }
              <Card>
                <Card.Body>
                  <LoginForm onSubmit={(event)=> loginClick(event)}>
                      <img src={logo} alt="logo" className="mt-3"/>
                      <div className="mt-5">
                        <h2 className="title">Login Parceiro</h2>
                      </div>
                      <InputDivOne>
                        <InputIcon>
                          <FaEnvelope color="#BF2F38" />
                        </InputIcon>
                        <InputRest>
                          <Input placeholder="E-mail" name="email" id="email" type="text" className="input" onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.email} />
                        </InputRest>
                      </InputDivOne>
                      {formik.touched.email && formik.errors.email && <span>{formik.errors.email}</span>}
                      <InputDivPass>
                        <InputIcon>
                          <FaLock color="#BF2F38" />
                        </InputIcon>
                        <InputRest>
                          <Input placeholder="Password" name="password" id="password" type="password" className="input" onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.password} />
                        </InputRest>
                      </InputDivPass>
                      {formik.touched.password && formik.errors.password && <span>{formik.errors.password}</span>}
                      {error && <span>{error}</span>}
                      
                      {loading ?
                      <Loader
                        type="ThreeDots"
                        color="#BF2F38"
                        height={50}
                        width={50}
                      /> :
                      <Button disabled={(formik.errors.email || formik.errors.password)}>Entrar</Button>}
                      <Link onClick={()=> forgetClick()}>Esqueceu a Password?</Link>
                  </LoginForm>
                </Card.Body>
              </Card> 
            </LoginContent>
          </Container>
        </LoginPage>
    );
}

export default Login;
